import request from 'superagent'
import types from '../types'

const { api_port } = require('../../../package.json')

const { protocol, hostname } = window.location
let app_url = `${protocol}//${hostname}:${api_port}`
if(api_port==='')
  app_url = `${protocol}//${hostname}`

const sendMailRequested = () => ({
  type: types.SEND_MAIL_REQUESTED,
  payload: null
})

const sendMailRejected = (error: any) => ({
  type: types.SEND_MAIL_REJECTED,
  payload: error
})

const sendMailFulfilled = (data: any) => ({
  type: types.SEND_MAIL_FULFILLED,
  payload: data
})

export const sendMail = (data: {emailTo: string, subject: string, type: string}) => {
  return (dispatch: any) => {
    dispatch(sendMailRequested())
    request
      .post(`${app_url}/sendMail`)
      .set('Accept', 'application/json')
      .send(data)
      .then((response) => {
        dispatch(sendMailFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(sendMailRejected(error))
      })
  }
}